import styled from '@emotion/styled'

export const WrapperComponent = styled.section`
  width: 95%;
  max-width: 1250px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
`